"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Divider = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _styles = require("./styles");
/**
 * Divider component.
 * @param {Object} props - React props
 */
var Divider = function Divider(_ref) {
  var className = _ref.className,
    _ref$vertical = _ref.vertical,
    vertical = _ref$vertical === void 0 ? false : _ref$vertical,
    materialProps = _ref.materialProps;
  var customClass = 'divider';
  var orientation = vertical ? 'vertical' : 'horizontal';
  if (className) customClass += " ".concat(className);
  return /*#__PURE__*/_react["default"].createElement(_styles.Styled, (0, _extends2["default"])({
    className: customClass,
    orientation: orientation
  }, materialProps));
};
exports.Divider = Divider;